export default __webpack_public_path__ + "static/media/I0002.340edb38.png";